module.exports = __webpack_public_path__ + "static/media/24.29f06067.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/24.JPG
// module id = 467
// module chunks = 0